import React from 'react';
import { motion } from 'framer-motion';
import { BotIcon, SparklesIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function Hero() {
  const navigate = useNavigate();
  const scrollToVideo = () => {
    const videoSection = document.getElementById('video-demo');
    if (videoSection) {
      videoSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative pt-20 pb-12 md:pt-32 md:pb-20 lg:pt-40 lg:pb-32 overflow-hidden" data-id="element-121">
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-50/50 via-white to-sky-50/30" data-id="element-122" />
      <div className="absolute top-20 right-10 w-48 h-48 md:w-72 md:h-72 bg-indigo-200/30 rounded-full blur-3xl" data-id="element-123" />
      <div className="absolute bottom-20 left-10 w-64 h-64 md:w-96 md:h-96 bg-sky-200/20 rounded-full blur-3xl" data-id="element-124" />
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8" data-id="element-125">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-127">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2
          }} className="inline-flex items-center space-x-2 px-3 py-1.5 md:px-4 md:py-2 bg-indigo-50 rounded-full mb-4 md:mb-6" data-id="element-128">
              <SparklesIcon size={14} className="text-indigo-600 md:w-4 md:h-4" data-id="element-129" />
              <span className="text-xs md:text-sm font-semibold text-indigo-600" data-id="element-130">
                AI-Powered Receptionist
              </span>
            </motion.div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-black mb-4 md:mb-6 leading-tight" data-id="element-131">
              Never Miss a Call Again
            </h1>
            <p className="text-base md:text-xl text-gray-600 mb-6 md:mb-8 leading-relaxed" data-id="element-132">
              WellAd answers your calls 24/7, schedules appointments, and
              captures leads so you can focus on growing your business.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-133">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} onClick={() => window.location.href = 'https://wellad.online/index.php/ai-voice-agent-onboarding/'} className="px-6 py-3 md:px-8 md:py-4 text-sm md:text-base bg-black text-white rounded-full font-semibold hover:shadow-2xl transition-all" data-id="element-134">
                Start Free Trial
              </motion.button>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} onClick={scrollToVideo} className="px-6 py-3 md:px-8 md:py-4 text-sm md:text-base bg-white/80 backdrop-blur-sm text-black rounded-full font-semibold border border-gray-200 hover:shadow-lg transition-all" data-id="element-135">
                Watch Demo
              </motion.button>
            </div>
            <div className="grid grid-cols-3 gap-4 md:gap-8" data-id="element-136">
              {[{
              value: '24/7',
              label: 'Availability'
            }, {
              value: '98%',
              label: 'Customer Satisfaction'
            }, {
              value: '5,000+',
              label: 'Calls Handled'
            }].map((stat, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.4 + index * 0.1
            }} data-id="element-137">
                  <div className="text-2xl md:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-indigo-600 to-sky-500 bg-clip-text text-transparent" data-id="element-138">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-gray-600 mt-1" data-id="element-139">
                    {stat.label}
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative" data-id="element-140">
            <div className="relative bg-gradient-to-br from-gray-50 to-white rounded-2xl md:rounded-3xl p-8 md:p-12 shadow-2xl border border-gray-100" data-id="element-141">
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-sky-500/5 rounded-2xl md:rounded-3xl" data-id="element-142" />
              <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-sky-500 rounded-2xl md:rounded-3xl blur opacity-20" data-id="element-143" />
              <div className="relative text-center" data-id="element-144">
                <motion.div animate={{
                y: [0, -10, 0],
                rotate: [0, 5, 0, -5, 0]
              }} transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="inline-flex items-center justify-center w-16 h-16 md:w-24 md:h-24 bg-gradient-to-br from-indigo-500 to-sky-500 rounded-xl md:rounded-2xl mb-4 md:mb-6 shadow-lg" data-id="element-145">
                  <BotIcon size={32} className="text-white md:w-12 md:h-12" data-id="element-146" />
                </motion.div>
                <h3 className="text-lg md:text-2xl font-bold text-black mb-2 md:mb-3" data-id="element-147">
                  AI Receptionist in Action
                </h3>
                <p className="text-sm md:text-base text-gray-600" data-id="element-148">
                  See how WellAd seamlessly handles your business calls
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}